import { render, staticRenderFns } from "./ScoreInfo.vue?vue&type=template&id=97ee8ece&"
import script from "./ScoreInfo.vue?vue&type=script&lang=js&"
export * from "./ScoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports